

import panelControl   			from './controllers/panelControl/panelControl';
import ordenesTrabajo 			from './controllers/ordenesTrabajo/ordenesTrabajo';
import incidencias    			from './controllers/incidencia/incidencias';
import inventario     			from './controllers/inventario/inventario';
import indicadores    			from './controllers/indicadores/indicadores';
import preincidencias 			from './controllers/preincidencias/preincidencias';
import ubicaciones    			from './controllers/ubicaciones/ubicaciones';
import alertas        			from './controllers/alertas/alertas';
import tipo_equipos   			from './controllers/tipo_equipos/tipo_equipos';
import protocolos     			from './controllers/protocolos/protocolos';
import tareas         			from './controllers/tareas/tareas';
import unidad_ejecutora   		from './controllers/unidadEjecutora/unidad_ejecutora';
import severidad	  			from './controllers/severidad/severidad';
import ott            			from './controllers/ott/ott';
import riesgo		  			from './controllers/riesgo/riesgo';
import tipoIncidencia 			from './controllers/tipo_incidencia/tipo_incidencia';
import prioridad	  			from './controllers/prioridad/prioridad';
import tipo_trabajo	  			from './controllers/tipo_trabajo/tipo_trabajo';
import tipo_falla	  			from './controllers/tipo_falla/tipo_falla';
import causa_falla	  			from './controllers/causa_falla/causa_falla';
import marca	  	  			from './controllers/marca/marca';
import proveedor  	  			from './controllers/proveedor/proveedor';
import proyecto  	  			from './controllers/proyecto/proyecto';
import centro_costo	  			from './controllers/centro_costo/centro_costo';
import usuario	  	  			from './controllers/usuario/usuario';
import empresa	  	  			from './controllers/empresa/empresa';
import rol	  	  	  			from './controllers/rol/rol';
import team	  	  	  			from './controllers/team/team';
import vehiculo	  	  			from './controllers/vehiculo/vehiculo';
import disponibilidadEquipo  	from './controllers/disponibilidad_equipo/disponibilidadEquipo';
import herramienta    			from './controllers/herramienta/herramienta';
import cliente        			from './controllers/cliente/cliente';
import reportes       			from './controllers/reportes/reportesController';
import panel          			from './controllers/panel/estadisticas';
import detalle		  			from './controllers/panel/detail';
import login		  			from './controllers/login/login';
import causa_falla_correctiva	from './controllers/causa_falla_correctiva/causa_falla';
import problema_correctivo 		from './controllers/problema_correctivo/problema_correctivo';

import menu           from './controllers/menu/menu';

import padreFilter from './filters/padreFilter';
import booleanFilter from './filters/booleanFilter';
import ottLabelFilter from './filters/ottLabelFilter';

//directivas
import onlyNumber from './directives/onlyNumbers';
import numbersDecimals from './directives/numbersDecimals';
import alphanumeric from './directives/alphanumeric';
import ngRut from './directives/ngRut';

import PreincidenciaToIncidencia from './services/preincidenciaToIncidencia';

import incidenciaService      from './services/incidenciaService';
import preincidenciasService  from './services/preincidenciasService';
import inventarioService      from './services/inventarioService';
import ubicacionService       from './services/ubicacionService';
import tipoEquipoService      from './services/tipoEquipoService';
import estadoEquipoService    from './services/estadoEquipoService';
import proveedorService       from './services/proveedorService';
import alertasService         from './services/alertasService';
import columnasService		  from './services/columnasService';
import severidadesService     from './services/severidadesService';
import imageService           from './services/imageService';
import clientesService        from './services/clientesService';
import proyectosService       from './services/proyectosService';
import centroCostosService    from './services/centroCostosService';
import unidadEjecutoraService from './services/unidadEjecutoraService';
import prioridadesService     from './services/prioridadesService';
import tipoIncidenciaService  from './services/tipoIncidenciaService';
import usuariosService        from './services/usuariosService';
import estadosService         from './services/estadosService';
import marcasService          from './services/marcasService';
import tipoFallaService       from './services/tipoFallaService';
import tipoOperacionService   from './services/tipoOperacionService';
import tipoUbicaciones        from './services/tipoUbicacionesService';
import causaFallaService      from './services/causaFallaService';
import protocolosService      from './services/protocolosService';
import tareasService          from './services/tareasService';
import herramientasService    from './services/herramientasService';
import objetoUbicacionService from './services/objetoUbicacionesService';
import ottService             from './services/ottService';
import riesgoService          from './services/riesgoService';
import tipoTrabajoService     from './services/tipoTrabajoService';
import CalendarioService      from './services/calendarioService';
import EquiposTecnicos        from './services/equiposTecnicos';
import Disponibilidad         from './services/disponibilidad';
import empresaService  		  from './services/empresasService';
import rolesService  		  from './services/rolesService';
import reportesService        from './services/reportesService';
import problemaCorrectivoService from './services/problemacorrectivoService';
import periodosService        from './services/periodosService';
import teamService  		  from './services/teamService';
import vehiculoService		  from './services/vehiculoService';
import panelService	  		  from './services/panelService';
import loginService			  from './services/loginService';
import causaFallaCorrectivaService			  from './services/causaFallaCorrectivaService';
import nivelIncidenciaService from './services/nivelIncidenciaService';

import ngRouteConfig from './config/ng_route';
import jwt from './config/jwt';
import blockUIConfig from './config/blockUI';
import authenticationInterceptor from './services/authenticationInterceptor'
// import run from './config/run';

const app = angular.module('mansys', ['ngRoute',
										'ngEnvVars.config',
										'angularUtils.directives.dirPagination',
										'datePicker',
										'ui.bootstrap',
										'ngFileUpload',
										'angular-jwt',
										'moment-picker',
										'ui.select',
										'ngSanitize',
										'ng-duallist',
										'yaru22.angular-timeago',
										'toastr',
										'ngAnimate',
                                        'angularValidator',
										'blockUI',
										'openlayers-directive']);
// la configuracion de ng-route
app.config(ngRouteConfig);
app.config(jwt);
// app.run(run);

app.service('info', [function(){
	this.default = 'default';
	this.set = (key, val) => {
		if (this[key]) {
			return false;
		}else{
			this[key] = val;
		}
	};

	this.get = (key) => {
		return this[key] || false;
	};

	this.permisos_g = (nombre) => {
		if (this.info.get('permisos') === undefined) {
			return false;
		}

		let diccionario = {
			'preincidencia': 'pi',
			'incidencia': 'in',
			'ott': 'ot',
			'equipos': 'eq',
			'administracion': 'adm',
			'panelcontrol': 'pc',
			'dashboard': 'dsb',
			'reporte': 'rp'
		};

		let aux = diccionario[nombre];

		if (this.info.get('permisos')[aux] && this.info.get('permisos')[aux].r){
			return true;
		}else{
			return false;
		}
	};
}]);


app.service('filtros', [function(){
	return {
		ott:{
			page: 1
		},
		incidencia:{
			page:1
		},
		preincidencia: {
			page:1 
		},
		inventario: {
			page: 1
		}
    };
}]);

app.config(blockUIConfig);

//servicios
app.service('PreincidenciaToIncidencia', [PreincidenciaToIncidencia]);

app.service('incidenciaService', ['$http', 'baseUrl', incidenciaService]);
app.service('preincidenciaService', ['$http', 'baseUrl', preincidenciasService]);
app.service('inventarioService', ['$http', 'baseUrl', inventarioService]);
app.service('ubicacionService', ['$http', 'baseUrl', ubicacionService]);
app.service('tipoEquipoService', ['$http', 'baseUrl', tipoEquipoService]);
app.service('estadoEquipoService', ['$http', 'baseUrl', estadoEquipoService]);
app.service('proveedorService', ['$http', 'baseUrl', proveedorService]);
app.service('alertasService', ['$http', 'baseUrl', alertasService]);
app.service('columnasService', [columnasService]);
app.service('severidadesService', ['$http', 'baseUrl', severidadesService]);
app.service('imageService', ['$http', 'baseUrl', imageService]);
app.service('clientesService', ['$http', 'baseUrl', clientesService]);
app.service('proyectosService', ['$http', 'baseUrl', proyectosService]);
app.service('centroCostosService', ['$http', 'baseUrl', centroCostosService]);
app.service('unidadEjecutoraService', ['$http', 'baseUrl', unidadEjecutoraService]);
app.service('prioridadesService', ['$http', 'baseUrl', prioridadesService]);
app.service('tipoIncidenciaService', ['$http', 'baseUrl', tipoIncidenciaService]);
app.service('usuariosService', ['$http', 'baseUrl', usuariosService]);
app.service('estadosService', ['$http', 'baseUrl', estadosService]);
app.service('marcasService', ['$http', 'baseUrl', marcasService]);
app.service('tipoFallaService', ['$http', 'baseUrl', tipoFallaService]);
app.service('tipoOperacionService', ['$http', 'baseUrl', tipoOperacionService]);
app.service('tipoUbicacionesService', ['$http', 'baseUrl', tipoUbicaciones]);
app.service('causaFallaService', ['$http', 'baseUrl', causaFallaService]);
app.service('protocolosService', ['$http', 'baseUrl', protocolosService]);
app.service('tareasService', ['$http', 'baseUrl', tareasService]);
app.service('herramientasService', ['$http', 'baseUrl', herramientasService]);
app.service('objetoUbicacionService', ['$http', 'baseUrl', objetoUbicacionService]);
app.service('ottService', ['$http', 'baseUrl', ottService]);
app.service('riesgoService', ['$http', 'baseUrl', riesgoService]);
app.service('problemaCorrectivoService', ['$http', 'baseUrl', problemaCorrectivoService]);
app.service('tipoTrabajoService', ['$http', 'baseUrl', tipoTrabajoService]);
app.service('CalendarioService', ['$http', 'baseUrl', CalendarioService]);
app.service('EquiposTecnicos', ['$http', 'baseUrl', EquiposTecnicos]);
app.service('Disponibilidad', ['$http', 'baseUrl', Disponibilidad]);
app.service('empresaService', ['$http', 'baseUrl', empresaService]);
app.service('rolesService', ['$http', 'baseUrl', rolesService]);
app.service('periodosService', ['$http', 'baseUrl', periodosService]);
app.service('teamService', ['$http', 'baseUrl', teamService]);
app.service('vehiculoService', ['$http', 'baseUrl', vehiculoService]);
app.service('reportesService', ['$http', 'baseUrl', reportesService]);
app.service('panelService', ['$http', 'baseUrl', panelService]);
app.service('authenticationInterceptor', authenticationInterceptor);
app.service('loginService',['$http', 'baseUrl', loginService]);
app.service('causaFallaCorrectivaService',['$http', 'baseUrl', causaFallaCorrectivaService]);
app.service('nivelIncidenciaService', ['$http', 'baseUrl', nivelIncidenciaService]);
//filtros
app.filter('padreFilter', padreFilter.filter);
app.filter('booleanFilter', booleanFilter.filter);
app.filter('ottLabelFilter', ottLabelFilter.filter);

//Directives
app.directive('onlyNumber', onlyNumber.create);
app.directive('numbersDecimals', numbersDecimals.create);
app.directive('alphanumeric', alphanumeric.create);
app.directive('ngRut', ngRut.create);

app.config( $httpProvider =>  {
    $httpProvider.interceptors.push('authenticationInterceptor');
});
//factorys
app.factory('dataEstadistica', function() {
	return {
		criterio: '',
		tipo: ''
	}
});
// controladores
app.controller('menuController', ['$location', '$scope', 'info', '$rootScope', menu]);

app.controller('preIncidenciasController',
	['$scope',
	'$routeParams',
	'$location',
	'method',
	'preincidenciaService',
	'PreincidenciaToIncidencia',
	'$uibModal',
	'toastr',
	'inventarioService',
	'info',
	'estadosService',
	'filtros',
	preincidencias]);

app.controller('ordenesTrabajoController', ['$scope', '$rootScope', ordenesTrabajo]);

app.controller('incidenciasController',
	['$scope',
	'$rootScope',
	'$location',
	'$routeParams',
	'method',
	'incidenciaService',
	'tipoEquipoService',
	'ubicacionService',
	'clientesService',
	'proyectosService',
	'inventarioService',
	'alertasService',
	'severidadesService',
	'centroCostosService',
	'unidadEjecutoraService',
	'prioridadesService',
	'tipoIncidenciaService',
	'PreincidenciaToIncidencia',
	'$uibModal',
	'usuariosService',
	'estadosService',
	'baseUrl',
	'objetoUbicacionService',
	'tipoUbicacionesService',
	'toastr',
	'info',
	'filtros',
	incidencias]);

app.controller('inventarioController',
	['$scope',
	'ubicacionService',
	'inventarioService',
	'$location',
	'$routeParams',
	'method',
	'tipoEquipoService',
	'estadoEquipoService',
	'columnasService',
	'proveedorService',
	'Upload',
	'imageService',
	'marcasService',
	'proyectosService',
	'$uibModal',
	'tipoFallaService',
	'baseUrl',
	'tipoOperacionService',
	'causaFallaService',
	'objetoUbicacionService',
	'tipoUbicacionesService',
	'clientesService',
	'toastr',
	'info',
	'$route',
	'filtros',
	inventario]);

app.controller('indicadoresController', ['$scope', indicadores]);

app.controller('panelControlController', ['$scope', panelControl]);

app.controller('ubicacionesController',
	['$scope',
	'$routeParams',
	'method',
	'ubicacionService',
	'tipoEquipoService',
	'clientesService',
	'proyectosService',
	'$location',
	'tipoUbicacionesService',
	'objetoUbicacionService',
	'$uibModal',
	'toastr',
	ubicaciones]);

app.controller('alertasController', [
	'$scope',
	'$routeParams',
	'alertasService',
	'severidadesService',
	'tipoEquipoService',
	'$location',
	'toastr',
    '$uibModal',
    'proyectosService',
	'objetoUbicacionService',
    'tipoUbicacionesService',
    'inventarioService',
    'ubicacionService',
	'method',
	alertas]);

app.controller('tipoEquiposController',
	['$scope',
	'$routeParams',
	'method',
	'tipoEquipoService',
	'severidadesService',
	'marcasService',
	'proveedorService',
	'tipoOperacionService',
	'$location',
	'$uibModal',
	'toastr',
	tipo_equipos]);


app.controller('protocolosController', [
					'$scope',
					'$routeParams',
					'method',
					'protocolosService',
					'tipoEquipoService',
      				'tipoTrabajoService',
					'$filter',
					'tareasService',
					'$q',
					'$location',
    				'$uibModal',
    				'toastr',
    				'proyectosService',
					protocolos]);

app.controller('tareasController', ['$scope',
									'method',
									'$routeParams',
									'tareasService',
									'herramientasService',
									'$filter',
									'$q',
									'riesgoService',
									'$location',
    								'$uibModal',
									'toastr',
 									tareas]);

app.controller('unidadEjecutoraController',
	['$scope',
	'$routeParams',
	'method',
	'unidadEjecutoraService',
	'$location',
	'$uibModal',
	'toastr',
	unidad_ejecutora]);

app.controller('severidadController',
	['$scope',
	'$routeParams',
	'method',
	'severidadesService',
	'$location',
    '$uibModal',
	'toastr',
	severidad]);


app.controller('ottController',
	['$scope',
	'$routeParams',
	'method',
	'ottService',
	'incidenciaService',
	'inventarioService',
	'protocolosService',
	'tareasService',
	'herramientasService',
	'prioridadesService',
	'proyectosService',
	'objetoUbicacionService',
	'ubicacionService',
	'baseUrl',
	'alertasService',
	'columnasService',
	'tipoUbicacionesService',
	'riesgoService',
	'$location',
	'$uibModal',
	'tipoFallaService',
	'causaFallaService',
	'estadosService',
	'CalendarioService',
	'EquiposTecnicos',
	'Disponibilidad',
	'$q',
	'periodosService',
	'vehiculoService',
	'clientesService',
	'toastr',
	'$route',
	'info',
	'tipoEquipoService',
	'Upload',
	'filtros',
	'problemaCorrectivoService',
	'causaFallaCorrectivaService',
	'nivelIncidenciaService',
	'$timeout',
	'$window',
	ott]);

app.controller('riesgoController',
	['$scope',
	'$routeParams',
	'method',
	'riesgoService',
	'$location',
	'$uibModal',
	'toastr',
	riesgo]);

app.controller('tipoIncidenciaController',
	['$scope',
		'$routeParams',
		'method',
		'tipoIncidenciaService',
		'$location',
        '$uibModal',
		'toastr',
		'info',
		tipoIncidencia]);

app.controller('prioridadController',
    ['$scope',
        '$routeParams',
        'method',
        'prioridadesService',
        '$location',
        '$uibModal',
        'toastr',
        prioridad]);

app.controller('tipoTrabajoController',
    ['$scope',
        '$routeParams',
        'method',
        'tipoTrabajoService',
        '$location',
        '$uibModal',
        'toastr',
        tipo_trabajo]);

app.controller('tipoFallaController',
    ['$scope',
        '$routeParams',
        'method',
        'tipoFallaService',
        '$location',
        '$uibModal',
        'toastr',
        tipo_falla]);

app.controller('causaFallaController',
    ['$scope',
        '$routeParams',
        'method',
        'causaFallaService',
        '$location',
        'toastr',
        '$uibModal',
		causa_falla]);
		
app.controller('causaFallaCorrectivaController',
		['$scope',
			'$routeParams',
			'method',
			'causaFallaCorrectivaService',
			'$location',
			'toastr',
			'$uibModal',
			'tipoEquipoService',
			causa_falla_correctiva]);		

app.controller('marcaController',
    ['$scope',
        '$routeParams',
        'method',
        'marcasService',
        '$location',
        '$uibModal',
        'toastr',
        marca]);

app.controller('proveedorController',
    ['$scope',
        '$routeParams',
        'method',
        'proveedorService',
        '$location',
        '$uibModal',
        'toastr',
        proveedor]);

app.controller('proyectoController',
    ['$scope',
        '$routeParams',
        'method',
        'proyectosService',
        'clientesService',
        '$location',
        '$uibModal',
		'toastr',
		'tipoEquipoService',
		'$q',
        proyecto]);

app.controller('centroCostosController',
    ['$scope',
        '$routeParams',
        'method',
        'centroCostosService',
        '$location',
        '$uibModal',
		'toastr',
		'proyectosService',
        centro_costo]);

app.controller('usuariosController',
    ['$scope',
        '$routeParams',
        'method',
        'usuariosService',
        'empresaService',
        'proyectosService',
        'clientesService',
        'rolesService',
        '$location',
        'toastr',
        '$uibModal',
        usuario]);

app.controller('empresasController',
    ['$scope',
        '$routeParams',
        'method',
        'empresaService',
        '$location',
        '$uibModal',
        'toastr',
        empresa]);

app.controller('rolesController',
    ['$scope',
        '$routeParams',
        'method',
        'rolesService',
        '$location',
        '$uibModal',
        'toastr',
        rol]);

app.controller('teamController',
    ['$scope',
        '$routeParams',
        'method',
        'teamService',
        '$location',
        '$uibModal',
		'toastr',
		'proyectosService',
        team]);

app.controller('disponibilidadEquipoController',
    ['$scope',
        '$routeParams',
        'method',
        'Disponibilidad',
        'teamService',
        '$location',
        '$uibModal',
        'toastr',
        disponibilidadEquipo]);

app.controller('vehiculoController',
    ['$scope',
        '$routeParams',
        'method',
        'vehiculoService',
        'marcasService',
        '$location',
        '$uibModal',
        'toastr',
        vehiculo]);

app.controller('reportesController',
	['$scope',
		'$routeParams',
		'method',
		'reportesService',
		reportes]);

app.controller('panelController',
	['$scope',
		'$routeParams',
		'panelService',
		'$location',
        'toastr',
        'dataEstadistica',
		'CalendarioService',
		'info',
		'clientesService',
		'proyectosService',
		'jwtHelper',
        panel]);

app.controller('detalleController',
	['$scope',
		'$routeParams',
		'panelService',
		'ottService',
		'incidenciaService',
		'preincidenciaService',
		'inventarioService',
		'$location',
		'toastr',
		'dataEstadistica',
		'CalendarioService',
		'clientesService',
		'proyectosService',
		'columnasService',
		'prioridadesService',
		detalle]);

app.controller('herramientaController',
    ['$scope',
        '$routeParams',
        'method',
        'herramientasService',
        '$location',
        '$uibModal',
        'toastr',
        herramienta]);

app.controller('clienteController',
    ['$scope',
        '$routeParams',
        'method',
        'clientesService',
        '$location',
        '$uibModal',
        'toastr',
        cliente]);

app.controller('loginController',
	['$scope',
		'$routeParams',
		'$location',
		'toastr',
		'loginService',
		'$rootScope',
		'info',
		login]);

app.controller('problemaCorrectivoController',
	['$scope',
		'$routeParams',
		'method',
		'problemaCorrectivoService',
		'$location',
		'toastr',
		'$uibModal',
		'tipoEquipoService',
		'proyectosService',
		problema_correctivo]);	

app.run(['$http', 'baseUrl', 'info', '$q','$rootScope', '$location', function($http, baseUrl, info, $q,$rootScope, $location){
	let url = baseUrl + '/login/inside';
	
	$rootScope.$on('$routeChangeStart', function(event, currRoute, prevRoute){	
		if ((typeof localStorage.getItem('token') == 'string') && (localStorage.getItem('token') !== null)) {
            $rootScope.isLogged = true;            
            if (!info.get('permisos')){            	
        	    var defer = $q.defer();
		        $http({
		            method: 'POST',
		            url: url
		        }).then(function(resp) {		        	
					let aux = resp.data[0];
					if(aux.proyectos.length > 0){
						localStorage.setItem('cliente', aux.proyectos[0].cliente.abreviacion)
					}	            
		            info.set('nombre', aux.nombre);
		            info.set('apellido', aux.apellido);
		            info.set('permisos', aux.permisos);
					info.set('flag_tecnico', aux.flag_tecnico);
					info.set('proyectos', aux.proyectos);
					localStorage.setItem('flag_tecnico', res.data.message.flag_tecnico);
		            defer.resolve();
		        })
		        .catch(function(err){
		        	defer.reject("Some error");
		        });
		        return defer.promise;			    
            }           
        } else {
            $rootScope.isLogged = false;
        }
    });	    
}]);



// WEBPACK FOOTER //
// ./app/js/app.js